import React from 'react';
import AsyncSelect from './Select/AsyncSelect';
import {getQueryName} from './utils';

/**
 * Ajax Return Stucture may by:

 return [
 [ 'label' => 'Label here', 'value' => 1 ]
 ]
 */

const loadOptions = (query, {returnName, labelName, valueName, likeLeft, likeRight, withoutValue, mutateData, filter}) => (
    async (inputValue) => {
        const queryName = getQueryName(query);
        if (!returnName) {
            returnName = 'data';
        }
        if (!valueName) {
            valueName = 'id';
        }

        if ( likeLeft === true ) {
            inputValue = '%' + inputValue;
        }
        if ( likeRight === true ) {
            inputValue = inputValue + '%';
        }

        let variables = {};
        variables[labelName] = inputValue;
        // Query the API for options.

        if(withoutValue) {
            if(typeof withoutValue === 'number'){
                variables[valueName] = withoutValue;
            }
            if(typeof withoutValue === 'object'){
                Object.keys(withoutValue).map( key => {
                    variables[key] = withoutValue[key]
                } )
            }
        }

        // console.log('#######################');
        // console.log(inputValue);
        // console.log(query);
        const {data} = await window.apolloClient.query({query, variables});
        // console.log(data);

        // Return the results.
        return mapOptions(data,
            {
                queryName, returnName, labelName, valueName, mutateData, filter
            }
        );
    }
);

const mapOptions = (data, {queryName, returnName, labelName, valueName, mutateData, filter}) => {
    console.debug({data, queryName, returnName});
    let entities = data[queryName][returnName];

    /*** remove entities which has been included in the filter array or string */
    if(filter && typeof filter === 'object') {
        for (const [key, value] of Object.entries(filter)) {
            let arrFilter = typeof value !== 'object' ? [value] : value;
            entities = entities.filter(
                /*** null or boolean values are also NaN;
                 * filter should be clearly numbers or strings(names) */
                e => !arrFilter.includes( isNaN( e[key] ) ? e[key] : parseInt( e[key] ) )
            )
        }
    }

    return entities.map((entity) => {
        if(queryName === 'findContacts') {
            entity[labelName] = [
                entity.company_name,
                entity.first_name,
                ' ',
                entity.last_name
            ].join('').trim();
        }

        let label = entity[labelName];

        if (mutateData) {
            label = mutateData(entity);
        }
        return {label, value: entity[valueName], entity};
    });
};

/**
 * @param query
 * @param labelName
 * @param valueName
 * @param likeLeft
 * @param likeRight
 * @param returnName
 * @param withoutValue
 * @param mutateData
 * @param {object} filter
 * @param props
 */
const FormAutocompleteGQL = (
        {query, labelName, valueName, likeLeft, likeRight, returnName, withoutValue, mutateData, filter , ...props}
    ) => {

    return (
        <AsyncSelect
            cacheOptions
            loadOptions={ loadOptions(
                query,
                {
                    returnName, labelName, valueName, likeLeft, likeRight, withoutValue, mutateData, filter
                }
            )}
            {...props}
        />
    );
};

FormAutocompleteGQL.defaultProps = {
    likeRight: true,
};

export default FormAutocompleteGQL;
